import type { ParagraphIntegrationsGrid as ParagraphIntegrationsGridData } from "@/lib/api/cms-catalog";
import type { ParagraphTranslations } from "../Paragraph.i18n";
import { HtmlText } from "../shared/HtmlText";
import styles from "./ParagraphIntegrationsGrid.module.css";

/**
 * Layout 42 - `PARAGRAPH_INTEGRATIONS_GRID_LAYOUT`: integracje grid 2x2.
 *
 * Struktura:
 *   - H2 (name) - tytul sekcji
 *   - Lead (text) - paragraf pod tytulem (HTML)
 *   - Grid 2-kol z kategorii integracji (max 4):
 *       - heading (uppercase teal)
 *       - lista pills (kazda integracja jako biały pill z borderem)
 *   - Puste grupy filtrowane po backendzie
 */
export function ParagraphIntegrationsGrid({
  paragraph,
}: {
  paragraph: ParagraphIntegrationsGridData;
  t: ParagraphTranslations;
}) {
  const { name: title, text: lead, groups } = paragraph;
  const hasLead = lead && lead.trim() !== "";
  const hasGroups = Array.isArray(groups) && groups.length > 0;

  return (
    <section className={styles.section}>
      <div className={styles.header}>
        {title ? <h2 className={styles.title}>{title}</h2> : null}
        {hasLead ? (
          <HtmlText html={lead} className={styles.lead} />
        ) : null}
      </div>
      {hasGroups ? (
        <div className={styles.grid}>
          {groups.map((group, idx) => (
            <div key={idx} className={styles.group}>
              {group.heading ? <p className={styles.heading}>{group.heading}</p> : null}
              {group.items && group.items.length > 0 ? (
                <ul className={styles.pills}>
                  {group.items.map((item, i) => (
                    <li key={i} className={styles.pill}>{item}</li>
                  ))}
                </ul>
              ) : null}
            </div>
          ))}
        </div>
      ) : null}
    </section>
  );
}
